var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.25C13 10.1119 13.1119 10 13.25 10C13.3881 10 13.5 10.1119 13.5 10.25V12.25C13.5 12.3881 13.3881 12.5 13.25 12.5C13.1119 12.5 13 12.3881 13 12.25V10.25Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10C10.1119 10 10 10.1119 10 10.25V12.25C10 12.3881 10.1119 12.5 10.25 12.5C10.3881 12.5 10.5 12.3881 10.5 12.25V10.25C10.5 10.1119 10.3881 10 10.25 10Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7H23V8H22V16H21V17H3V16H2V8H1V7ZM12 9.5C12 9.22386 12.2239 9 12.5 9H20V15H12.5C12.2239 15 12 14.7761 12 14.5V9.5ZM11 9H4V15H11C11.2761 15 11.5 14.7761 11.5 14.5V9.5C11.5 9.22386 11.2761 9 11 9Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBar);
export default __webpack_public_path__ + "static/media/back_bar.2623fd961c23afd45fdb135cdcb53e00.svg";
export { ForwardRef as ReactComponent };